import PropTypes from "prop-types";
import styles from "./CompanyContainer.module.css";
import { Fragment, useEffect, useRef, useState } from "react";
import Axios from "axios";
import NewCompanyModel from "./AddCompany/NewCompanyModel";
import config from "../../../../service/config";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useNavigate } from "react-router-dom";
import companyStore from "../../CompanyStore";
import { Spin } from "antd";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { useAllProduct } from "../../../api-context/commonApiContext";
const PageContainer = () => {
  const { authTokens, role, refreshData, loader, setLoader, userData, isTokenValid, getNewTokens } = useAllProduct();
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [compName, setCompName] = useState(""); // Move state to parent
  const [errorMsg, setErrorMsg] = useState("");
  const [showModel, setShowModel] = useState(false);
  const [currentcompid, setCurrentCompId] = useState("");
  const [createdDateFilter, setCreatedDateFilter] = useState(null);
  const [textFilter, setTextFilter] = useState("");
  const [currentCompName, setCurrentCompName] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [searchedByDate, setSearchedByDate] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const modalRef = useRef(null);

  const fetchCompanyAndUserData = async () => {
    try {
      if (Object.keys(authTokens).length > 0) {
        setLoader(true);
        const payload = {
          escrow_id: companyStore.escrowId,
        };

        if (!isTokenValid(authTokens.idToken)) {
          console.log("Token invalid or expired, refreshing...");
          await getNewTokens();
          const updatedAuthTokens = JSON.parse(localStorage.getItem("authTokens"));
          if (!updatedAuthTokens?.idToken || !isTokenValid(updatedAuthTokens.idToken)) {
            console.error("Failed to refresh token or new token is invalid.");
            setLoader(false);
            return;
          }
          authTokens.idToken = updatedAuthTokens.idToken; // Update local reference
        }

        // Fetch company data
        const companyRes = await Axios.post(`${config.node_api_endpoint}/v2/company/list`, payload, {
          headers: {
            aws_cognito_id_token: authTokens.idToken,
            "Content-Type": "application/json",
          },
        });
        console.log("companyRes", companyRes);

        if (!companyRes.data || companyRes.data.message) {
          console.log("No valid company data returned or error message received.");
          setData([]);
          setFilteredData([]);
          setLoader(false);
          return;
        }

        const sortedCompanyData = companyRes.data.sort((a, b) => {
          const dateA = dayjs(a.created_at, "DD MMM YYYY / hh:mm a");
          const dateB = dayjs(b.created_at, "DD MMM YYYY / hh:mm a");
          return dateB - dateA; // Newest first
        });

        // Merge with user data
        const mergedData = sortedCompanyData.map((company) => {
          const createdByUser = userData.find((user) => user.email === company.created_by);
          return {
            ...company,
            role: createdByUser ? createdByUser.auth[0].role : "N/A", // Fallback to "N/A"
          };
        });

        setData(mergedData);
        setFilteredData(mergedData);
      }
    } catch (error) {
      console.error("Error fetching company or user data:", error);
      if (error.response?.data?.error === "Token has expired. Please log in again.") {
        console.log("Token expired during request, refreshing...");
        await getNewTokens();
        const updatedAuthTokens = JSON.parse(localStorage.getItem("authTokens"));
        if (updatedAuthTokens?.idToken && isTokenValid(updatedAuthTokens.idToken)) {
          return fetchCompanyAndUserData(); // Retry with new token
        }
      }
      setData([]);
      setFilteredData([]);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    fetchCompanyAndUserData();
  }, [showModel, authTokens, userData]);

  useEffect(() => {
    setFilteredData([]); // Reset the filtered data to an empty array

    setCurrentPage(0);
    fetchCompanyAndUserData(); // Re-fetch data instead of reloading the page
  }, [refreshData]);

  useEffect(() => {
    if (showModel) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showModel]);

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setShowModel(false);
      setCompName(""); // Reset compName
      setErrorMsg(""); // Reset errorMsg
    }
  };

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const resetFilters = () => {
    setFilteredData(data);
  };

  const applyFilters = () => {
    setTextFilter("");
    let filtered = data;

    if (createdDateFilter) {
      filtered = filtered.filter((item) => {
        const [datePart] = item.created_at.split(" / "); // Extract date part
        const itemDate = dayjs(datePart, "DD MMM YYYY").format("YYYY-MM-DD"); // Parse and format
        const filterDate = dayjs(createdDateFilter).format("YYYY-MM-DD");

        console.log("Parsed itemDate:", itemDate, "Parsed filterDate:", filterDate);

        return itemDate === filterDate;
      });
    }

    if (textFilter) {
      filtered = filtered.filter((item) => item.status === textFilter);
    }
    setSearchedByDate(filtered);
    setFilteredData(filtered);
    setCurrentPage(0);
  };

  const handleTextFilterChange = (e) => {
    const value = e.target.value;
    setTextFilter(value);

    let filtered = searchedByDate?.length > 0 ? searchedByDate : data;

    if (value) {
      filtered = filtered.filter(
        (item) =>
          item.created_at.toLowerCase().includes(value.toLowerCase()) ||
          item.created_by.toLowerCase().includes(value.toLowerCase()) ||
          item?.role[0]?.toLowerCase().includes(value.toLowerCase()) ||
          item.name.toLowerCase().includes(value.toLowerCase()),
      );
    }

    setFilteredData(filtered);
    if (!value) setFilteredData(filtered);
    setCurrentPage(0);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };
  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handlePaginationChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const startIndex = (currentPage - 1) * pageSize;
  // const currentPageData = filteredData.slice(startIndex, startIndex + pageSize);
  const currentPageData = filteredData.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage);

  return (
    <>
      <div className={`${styles.pageContainer} ${styles.family} h-100 w-100`}>
        <Spin
          size="large"
          tip="Loading..."
          spinning={loader}
          className="d-flex justify-content-center align-items-center w-100 h-100"
          style={{ maxHeight: "none" }}
        >
          <div className="d-flex justify-content-between">
            <b
              className={`${styles.escrowName} mt-2 mb-2`}
              title={companyStore.escrowName.length > 50 ? companyStore.escrowName : ""}
            >
              {companyStore.escrowName.length > 50
                ? companyStore.escrowName.slice(0, 50) + "..."
                : companyStore.escrowName}
            </b>
            <button
              onClick={() => {
                setShowModel(true);
              }}
              className={`${styles.newCompany} ${styles.loadsButtons} ${role.toString() === "Owner" || role.toString() === "Super Admin" || role.toString() === "Admin" || role.toString() === "Maker" ? "" : styles.disabledDiv}`}
              // className=
              disabled={
                role.toString() === "Owner" ||
                role.toString() === "Super Admin" ||
                role.toString() === "Admin" ||
                role.toString() === "Maker"
                  ? false
                  : true
              }
            >
              <img className={styles.plusCircleIcon} alt="" src="/pluscircle.svg" />
              <b className={`${styles.addNewCompany}`}>New Company</b>
            </button>
          </div>

          <div className={`${styles.searchFiltersParent} p-2 mt-2 mb-2`}>
            <div className={"w-100 d-flex justify-content-center align-items-center"}>
              <div className={"w-25"}>
                <div className="d-flex">
                  <img className={styles.leadingIcon} alt="" src="/leadingicon.svg" />
                  <TextField label="Search" variant="standard" value={textFilter} onChange={handleTextFilterChange} />
                </div>
              </div>

              <div className={`${styles.mobileMenuParent} w-75 d-flex justify-content-end `}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Created Date"
                    value={createdDateFilter}
                    onChange={(newValue) => setCreatedDateFilter(newValue)}
                    renderInput={(params) => <TextField {...params} />}
                    maxDate={dayjs()}
                    sx={{
                      "& .MuiInputBase-root": {
                        // width: "250px",
                        borderRadius: "12px",
                      },
                    }}
                  />
                </LocalizationProvider>

                <div className={styles.loadsButtons1} onClick={applyFilters}>
                  <img className={styles.boxArrowInDownIcon} alt="" src="/boxarrowindown1.svg" />
                  <b className={styles.addNewCompany}>Apply</b>
                </div>
              </div>

              {/* Frame Container ends */}
            </div>
          </div>
          <div className={`${`${styles.tableBg} d-flex justify-content-between p-2`}`}>
            <h2 className={styles.title}>Company List</h2>
          </div>
          <Paper>
            <TableContainer>
              <Table>
                <TableHead
                  className={styles.tableBg}
                  sx={{
                    "& .MuiTableCell-root": {
                      padding: "16px",
                    },
                  }}
                >
                  <TableRow>
                    <TableCell align="center">Created Date</TableCell>
                    <TableCell align="center">Company Name</TableCell>
                    <TableCell align="center">Created By</TableCell>
                    <TableCell align="center">Role</TableCell>
                    <TableCell align="center">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentPageData.length > 0 ? (
                    currentPageData.map((detail) => (
                      <TableRow key={detail._id} sx={{ "& .MuiTableCell-root": { padding: "8px" } }}>
                        <TableCell align="center">{detail.created_at}</TableCell>
                        <TableCell align="center" title={detail.name.length > 30 ? detail.name : ""}>
                          {detail.name.length > 30 ? detail.name.slice(0, 30) + "..." : detail.name}
                        </TableCell>
                        <TableCell align="center">{detail.created_by}</TableCell>
                        <TableCell align="center">{detail.role}</TableCell>
                        <TableCell align="center">
                          <Button
                            className={styles.change}
                            style={{ color: "#2348AB", textDecoration: "underline", textTransform: "lowercase" }}
                            onClick={() => {
                              handleScrollToTop();
                              setCurrentCompId(detail._id);
                              setCurrentCompName(detail.name);
                              companyStore.setCompanyID(detail.id);
                              companyStore.setCompanyName(detail.name);
                              console.log(detail._id);
                              navigate("/content/company/kyclist/main");
                            }}
                          >
                            {"View More"}
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        No Records Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              className={`${styles.tableBg}`}
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={currentPage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                "& .MuiTablePagination-selectLabel": {
                  marginTop: "14px",
                },
                "& .MuiTablePagination-displayedRows": {
                  marginTop: "14px",
                },
              }}
            />
          </Paper>
          <NewCompanyModel
            isVisible={showModel}
            setShowModel={setShowModel}
            onclose={() => {
              setShowModel(false);
            }}
            compName={compName}
            setCompName={setCompName} // Pass setter
            errorMsg={errorMsg}
            setErrorMsg={setErrorMsg}
            setLoader={setLoader}
            modalRef={modalRef}
          />
        </Spin>
      </div>
    </>
  );
};

PageContainer.propTypes = {
  className: PropTypes.string,
};

export default PageContainer;
